import { Model } from "pinia-orm";
import Mission from "./Mission.js";

export default class Audit extends Model {
  static entity = "audits";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(),
      createdAt: this.string(""),
      updatedAt: this.string(""),
      isCurrent: this.boolean(false),
      isHistorical: this.boolean(false),

      questionnaireSessionUuid: this.string(null),

      mission: this.belongsTo(Mission, "missionId"),
      missionCode: this.string(""),
      missionId: this.string(null),
      activityNatureCode: this.string(""),
      activityNatureLabel: this.string(""),
      domainCode: this.string(""),
      domainLabel: this.string(""),
      additionalMissionCodes: this.attr([]),

      author: this.string(""),

      evaluator: this.string(""),
      evaluatorUsermanagementUuid: this.string(""),
      evaluatorEmail: this.string(""),
      auditedUsers: this.attr([]),
      auditedUsersEmails: this.attr([]),

      auditType: this.string(""),
      auditTypeCode: this.string(""),
      description: this.string(""),
      caseNumber: this.string(""),
      caseReference: this.string(""),
      interventionReference: this.string(""),
      activityNature: this.string(""),
      domain: this.string(""),
      missionChoiceCriteria: this.string(""),
      evaluatedReportsReferences: this.string(""),

      umAgencyUuid: this.string(""),

      evaluationDate: this.string(""),
      programmationDate: this.string(""),
      monitoringValidationDate: this.string(""),

      questionnaireResultsDocument: this.string(""),

      status: this.string(""),
      isArchived: this.boolean(false),
      score: this.number(0),
    };
  }

  // Define relationships for easier access
  static with = ["questionnaireConfig", "mission", "author", "evaluator", "domain"];
}
